export const StoreLinkWithImage = ({img, link}) => {
  return (
    <a href={link} target="_blank" rel="noreferrer">
      <img src={img} alt="" />
    </a>
  );
};
